import dayjs from "dayjs";
import {notification} from "antd";
import {v4 as uuidv4} from 'uuid';
import * as BUCKETS from "../enums/buckets";
import {ReactNode} from "react";

export const goToPreviousPage = () => {

}

export const getTodayDate = () => {
  return dayjs().format('DD/MM/YYYY')
}

export const getImageLink = (props: { imageId: string, bucketId: string }) => {
  const {imageId, bucketId} = props
  return `https://cloud.appwrite.io/v1/storage/buckets/${bucketId}/files/${imageId}/view?project=67232f8c003094e2430c`
}
export const openSuccessNotification = (message: string) => {
  notification.success({
    message: message,
    placement: 'topRight', // You can adjust the placement of the notification
  });
};

export const openWarningNotification = (message: string) => {
  notification.warning({
    message: message,
    placement: 'topRight'
  })
}

export const showErrorNotification = (props: { message: string, description?: ReactNode }) => {
  const {message, description} = props
  notification.error({
    message: message,
    description: description,
    placement: 'topRight',
    duration: 0
  });
};


export const getRandomId = () => uuidv4()

export const navigateBackHandler = () => {
  window.history.back()
}


export const getFullImagesData = (imagesId: string[]) => {
  if (imagesId && imagesId.length) {
    return imagesId.map((imageId) => {
      return {
        uid: imageId,
        name: imageId,
        url: getImageLink({imageId: imageId, bucketId: BUCKETS.MAIN}),
        response: {$id: imageId}
      }
    })
  }
  return []
}
